/* eslint-disable */
export default {
  // TODO: Hoai: layout default date
  appInfo: {
    key: "layout_appinfo",
    data: {
      appName: " Quản lý hồ sơ",
      appLogoImage: require("@/assets/images/logo/quoc_huy_VN.png"),
      moreData: null,
    },
  },

  header: {
    key: "layout_header",
    data: {
      title: "",
    },
  },

  footter: {
    key: "layout_footter",
    data: {
      title: "",
    },
  },
};
